import Template from './Template';

export default function AuthLanding() {
  return (
    <div className="w-full h-full">
      <Template />
    </div>
  );
}
